import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import styles from "./pages.module.css";

import { getCreator } from "../api/Api"
import { useMediaUpdate } from "../contexts/MediaContext";

import { AuthorBanner } from "../comonents/Banners/AuthorBanner";
import { Footer } from "../comonents/Footer/Footer";
import { useUpdateNavigationContext } from "../contexts/NavagationContext";
import ErrorHandler from "../helpers/ErrorHandler";

export default function Author() {

    // ----------------------------------------------------- STATE AND HOOKS

    const setCurrentLocation = useUpdateNavigationContext();
    setCurrentLocation("creator")

    const authorID = useParams().id;
    const [author, setAuthor] = useState({});

    let token = localStorage.getItem("token");

    const bookUpdater = useMediaUpdate();

    useEffect(() => {
        // gets author on first render
        fetchAuthor();
        bookUpdater({}); //resets book to avoid flash
    }, [authorID]);


    // ----------------------------------------------------- PRE-RENDER

    async function fetchAuthor(){
        // fetches author from back
        await getCreator(authorID, token)
            .then((foundAuthor) => {
                setAuthor(foundAuthor);
            })
            .catch((error) => {
                console.log("failed to get author");
                console.log(error);
                ErrorHandler(error);
            })
    }

    // ----------------------------------------------------- RENDER

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <AuthorBanner authorItem = {author}/>
            </div>
                
            <Footer />
        </div>
    );
}